import { IVROption, SupportedLanguages } from '@pwp-common';

import { RowCell } from '../../../../../common/p-table/row-cell';
import { summarizeVRCArray } from '../../../service-operation-editor/summarize-vrc-array/summarize-vrc-array';

import { IVROptionEditorRow } from './interfaces';

//////////////////////////////////////////////////////////////////////////////////////////
// IVR Option editor row
//////////////////////////////////////////////////////////////////////////////////////////

export const createIVROptionEditorRow = (ivrOption: IVROption, index: number): IVROptionEditorRow => {
  const keyPresses = ivrOption.getKeyPresses().join(', ');
  const phrases = ivrOption.getPhrases().get(SupportedLanguages.en.getShortCode()) ?? [];
  const commaSeparatedPhrases = phrases?.join(', ') ?? '';

  return {
    id: `${ivrOption.getDisplayName()}-${index}`,
    displayName: createValueCell(ivrOption.getDisplayName()),
    description: createValueCell(ivrOption.getDescription()),
    keyPresses: createValueCell(keyPresses),
    phrases: createValueCell(commaSeparatedPhrases),
    summary: summarizeVRCArray(ivrOption.getCommands()),
    ivrOption,
    optionIndex: index,
  };
};

//////////////////////////////////////////////////////////////////////////////////////////
// Value cell
//////////////////////////////////////////////////////////////////////////////////////////

const createValueCell = (value: string): RowCell<string> =>
  new RowCell<string>({
    translationScope: 'ivr-option-table-editor',
    translationKey: 'cellValue',
    translationObj: { value },
    sortValue: value,
  });
